import script from "./loading.vue?vue&type=script&lang=ts&setup=true"
export * from "./loading.vue?vue&type=script&lang=ts&setup=true"

import "./loading.vue?vue&type=style&index=0&id=bc7e0024&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/efs/var/www/3tgds.com/scm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc7e0024"]])

export default __exports__